module.exports = __webpack_public_path__ + "media/images/icons/filled/twitter-circle-56a404be99d1c89d8222399eb8fa9d1a.svg";